<script lang="ts" setup>
import type { Component } from 'vue';
import {
    AppWindow,
    Calculator,
    Check,
    ChevronRight,
    CircleAlert,
    CircleHelp,
    ExternalLink,
    File,
    FileArchive,
    FileChartPie,
    FileImage,
    FilePen,
    FilePlay,
    FileSpreadsheet,
    FileText,
    FileTypeCorner,
    Folder,
    Megaphone,
    Presentation,
    User,
    X,
    Lightbulb
} from 'lucide-vue-next';

// this needs to be kept up-to-date with the "lucideIcon" field in Craft

const iconMap: Record<string, Component> = {
    'app-window': AppWindow,
    calculator: Calculator,
    check: Check,
    'chevron-right': ChevronRight,
    'circle-alert': CircleAlert,
    'circle-help': CircleHelp,
    'external-link': ExternalLink,
    file: File,
    'file-archive': FileArchive,
    'file-chart-pie': FileChartPie,
    'file-image': FileImage,
    'file-pen': FilePen,
    'file-play': FilePlay,
    'file-spreadsheet': FileSpreadsheet,
    'file-text': FileText,
    'file-type-corner': FileTypeCorner,
    folder: Folder,
    megaphone: Megaphone,
    presentation: Presentation,
    user: User,
    x: X,
    lightbulb: Lightbulb
};

type CraftLucideIcons = keyof typeof iconMap;

defineProps<{
    icon: CraftLucideIcons;
}>();
</script>

<template>
    <component :is="iconMap[icon]" />
</template>
